// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1e_Cl","content":"RecentSearches_content__1pUnt"};